import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

function cleanInput(input = {}) {
    const cleaned = {
        label: String(input.label == null ? '' : input.label).trim(),
        keyType: String(input.keyType == null ? '' : input.keyType).trim(),
        number: String(input.number == null ? '' : input.number).trim(),
        holder: parseInt(input.holder, 10) || 0,
        note: String(input.note == null ? '' : input.note).trim(),
    };
    // Forward the domain club (appState.currentCustomer.id) when the caller provides one, so
    // the backend can pin the key to the club whose site issued it rather than the officer's
    // personal "My account" customer. Omitted when not present so existing callers are unaffected.
    if (input.customer != null) {
        cleaned.customer = parseInt(input.customer, 10) || 0;
    }
    return cleaned;
}

class ClubKeyStore extends LocalModel {
    constructor() {
        super('clubKey', {
            namePlural: 'clubKeys',
            namePluralReal: 'clubkeys',
            sort: '-createdDate',
            limit: 50,
            api: {
                search: {
                    url: '/api/clubkeys/',
                    params: {},
                },
                load: {
                    url: '/api/clubkeys/',
                    params: {},
                },
                save: {
                    url: '/api/clubkeys/',
                    params: {},
                },
                delete: {
                    url: '/api/clubkeys/',
                    params: {},
                },
            },
        });
    }

    @observable clubKeys = [];

    @observable myKeys = [];

    @observable clubKey = {};

    @observable isLoading = false;

    @observable lastError = '';

    @action
    async loadKeys(filter = {}) {
        this.updateKeyValue('isLoading', true);
        const { outstanding, unconfirmed } = filter;
        const params = {};
        if (outstanding) params.outstanding = 1;
        if (unconfirmed) params.unconfirmed = 1;
        const response = await util.fetchApi('/api/clubkeys/', { method: 'GET' }, params);
        if (response?.status === 200) {
            this.updateKeyValue('clubKeys', response.data || []);
        }
        this.updateKeyValue('isLoading', false);
        return response;
    }

    @action
    async loadMine() {
        this.updateKeyValue('isLoading', true);
        const response = await util.fetchApi('/api/clubkeys/my', { method: 'GET' }, {});
        if (response?.status === 200) {
            this.updateKeyValue('myKeys', response.data || []);
        }
        this.updateKeyValue('isLoading', false);
        return response;
    }

    @action
    async addKey(input) {
        const response = await util.fetchApi('/api/clubkeys/', { method: 'POST' }, cleanInput(input));
        return this.afterWrite(response, () => this.loadKeys());
    }

    @action
    async updateKey(id, input) {
        const response = await util.fetchApi(`/api/clubkeys/${id}`, { method: 'PATCH' }, cleanInput(input));
        return this.afterWrite(response, () => this.loadKeys());
    }

    @action
    async confirmKey(id) {
        const response = await util.fetchApi(`/api/clubkeys/${id}/confirm`, { method: 'POST' }, {});
        return this.afterWrite(response, () => this.loadMine());
    }

    @action
    async returnKey(id) {
        const response = await util.fetchApi(`/api/clubkeys/${id}/return`, { method: 'POST' }, {});
        return this.afterWrite(response, () => this.loadKeys());
    }

    @action
    async afterWrite(response, reload) {
        if (response?.status === 201 || response?.status === 202) {
            this.updateKeyValue('lastError', '');
            await reload();
        } else {
            this.updateKeyValue('lastError', response?.message || 'Could not save');
        }
        return response;
    }
}

const store = new ClubKeyStore();
export default store;
